import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

import { BetState } from '@bpos/v1/my-bets';
import { EpcotConfig, MyBetsConfig, SitecoreMyBetsConfig } from '@frontend/sports/common/client-config-data-access';

import { EarlyPayoutPickState } from '../../../my-bets-base/models/early-payout-types';
import { MyBetsBet } from '../../../my-bets-base/models/my-bets-viewmodels';
import { MyBetsUtilService } from '../../services/my-bets-util.service';

interface BetResult {
    bet: MyBetsBet;
    state: BetState | EarlyPayoutPickState;
}

@Component({
    selector: 'ms-my-bets-multi-bet-card-collapsed',
    templateUrl: 'my-bets-multi-bet-card-collapsed.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class MyBetsMultiBetCardCollapsedComponent implements OnInit {
    @Input({ required: true }) bets: MyBetsBet[];
    @Input({ required: true }) betResults: BetResult[];
    @Input({ required: true }) isLive: boolean;

    isBetbuilderCombo = false;
    isEpcotEnabled = false;

    constructor(
        public sitecoreMyBets: SitecoreMyBetsConfig,
        public myBetsConfig: MyBetsConfig,
        public myBetsUtilService: MyBetsUtilService,
        private epcotConfig: EpcotConfig,
    ) {
        this.isEpcotEnabled = this.epcotConfig.isEnabled;
    }

    ngOnInit(): void {
        this.isBetbuilderCombo = this.bets.some((bet) => bet.betBuilderInfo);
    }

    getExpandedCardState(bet: MyBetsBet): BetState | EarlyPayoutPickState | undefined {
        return this.betResults.find((betState) => betState.bet === bet)?.state;
    }
}
